// extracted by mini-css-extract-plugin
export var anchor = "_4f-0";
export var discard = "_4f-4";
export var muiTooltipTooltip = "_4f-6";
export var notificationBar = "_4f-3";
export var saveButtonHoverSlotWrapper = "_4f-5";
export var show = "_4f-2";
export var spacer = "_4f-1";